import React from 'react';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { CustomerContactsAvatarGroup } from '@css-xp/ppc-subscription-table';
import { useFetchEndCustomerContactstPPCQuery } from '@css-xp/ppc-entitlement-page';
import { EndCustomerContact } from '@css-xp/graphtypes/src/generated-types-new';
import './invoice-customer-contact.scss';
interface InviceContactDetails {
  entitlementId: string;
  transactionAccountId: string;
}

const CellLoader = () => (
  <SkeletonLoaderWrapper>
    <SkeletonLoader width="60%" marginBottom="0" />
  </SkeletonLoaderWrapper>
);

export const InvoiceCustomerContact = ({ entitlementId, transactionAccountId }: InviceContactDetails) => {
  const { data, loading: fetchECCLoading } = useFetchEndCustomerContactstPPCQuery({
    transactionAccountId,
    entitlementId: entitlementId,
  });
  const endCustomerContacts = data?.entitlementDetails?.endCustomerContacts as Array<EndCustomerContact>;

  return fetchECCLoading ? <CellLoader /> : <CustomerContactsAvatarGroup contacts={endCustomerContacts} />;
};
